import React from 'react'
import styles from './styles.module.scss'

function DataPill({ text, type = '', renderIcon, className, longitude, latitude }) {
  return (
    <div className={`${styles.container} ${className}`}>
      <span className={styles.icon}>{renderIcon()}</span>
      {type === 'address' && (
        <a target='_blank' href={`https://maps.google.com?q=${latitude},${longitude}`} className={styles.text}>
          {text}
        </a>
      )}
      {type === 'link' && (
        <a target='_blank' href={text} className={styles.text}>
          {text}
        </a>
      )}
    </div>
  )
}

export default DataPill
